import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { BottomNavigation } from 'components/shared/BottomNavigation'
import { Breadcrumbs } from 'components/shared/Breadcrumbs'
import { Footer } from 'components/shared/Footer'
import { GlobalNoScrollbarWrapper } from 'components/shared/GlobalNoScrollbarWrapper'
import { Header } from 'components/shared/Header'
import { LimitContentWidth } from 'components/shared/LimitContentWidth'
import colors from 'helpers/colors'
import { FC, ReactNode } from 'react'

const HEADER_AND_FOOTER_HEIGHT = 340
const HEADER_AND_ONLY_LOGO_FOOTER_HEIGHT = 156
const HEADER_AND_ONLY_LOGO_FOOTER_HEIGHT_FOR_XS = 104

const generateMinHeight = (xs: boolean, onlyLogo: boolean) => {
  if (!onlyLogo) {
    return HEADER_AND_FOOTER_HEIGHT
  }

  return xs
    ? HEADER_AND_ONLY_LOGO_FOOTER_HEIGHT_FOR_XS
    : HEADER_AND_ONLY_LOGO_FOOTER_HEIGHT
}

type Props = {
  onlyLogo: boolean
  hideFooter?: boolean
  fullScreen?: boolean
  breadCrumbs?: { text: string; href?: string }[]
  contentStyles?: object
  children: ReactNode
}

export const DefaultLayout: FC<Props> = ({
  children,
  onlyLogo,
  hideFooter,
  fullScreen,
  breadCrumbs = [],
  contentStyles = {},
}) => {
  const { xs } = useBreakpoint()

  return (
    <>
      <GlobalNoScrollbarWrapper>
        <Header onlyLogo={onlyLogo} />
        <div
          style={{
            maxWidth: fullScreen ? '100%' : '1280px',
            margin: '0 auto',
            minHeight: `calc(100vh - ${generateMinHeight(!!xs, !!onlyLogo)}px)`,
            WebkitFontSmoothing: 'antialiased',
            color: colors.primary,
            ...contentStyles,
          }}
        >
          {children}
        </div>
        {breadCrumbs.length > 0 && (
          <LimitContentWidth>
            <Breadcrumbs breadcrumbs={breadCrumbs} xs={xs} />
          </LimitContentWidth>
        )}
        {!hideFooter && <Footer onlyLogo={onlyLogo} />}
        {xs && <BottomNavigation />}
      </GlobalNoScrollbarWrapper>
    </>
  )
}
